import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { AppDispatch } from '../store';  
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";

export function useThunk<ArgType = void>(thunk: (arg: ArgType) => any) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const dispatch = useDispatch<AppDispatch>(); 
  const navigate = useNavigate();

  const runThunk = useCallback(
    (arg: ArgType): void => {
      setIsLoading(true);
      dispatch(thunk(arg))
        .unwrap()
        .catch((err: any) =>setError(err))
        .finally(() => setIsLoading(false));
    },
    [dispatch, thunk]
  );

  return { runThunk, isLoading, error };
}
